import indicators from './material-indicators.json'

export const CORE_REQUIRED_INDICATOR_IDS = [1, 8, 13, 15, 19]

export default indicators
